import * as THREE from 'three';
import { World } from '../worlds/World';
import * as ObjectCreation from '../ObjectCreation';
import * as TextCreation from '../TextCreation';
import { OrbFactory } from '../../../orbs/OrbFactory';
import { global } from '../../../core/GlobalState';
import { registerScenePolicy } from '../../../core/ScenePolicies';
import { createPortalOrb } from '../worlds/WorldBuilderHelpers';
import { buildGiantRainbowCylinderStack, getStackRegionOrb } from '../DynamicSystemDesignModel';
import '../../networking/TrafficStreamBridge';
import { liveStreamRegistry } from '../../networking/LiveStreamRegistry';
const startSprayPosition = new THREE.Vector3(2000, 5000, -2000);
const networkGatewayStackCenter = new THREE.Vector3(-6500, 1200, -800);
function addWelcomeMessage(scene) {
    const existing = scene.getObjectByName('systemWelcomeText');
    if (existing) {
        scene.remove(existing);
    }
    const sprite = TextCreation.createTextSprite('Start', 2, new THREE.Vector3(50, 25, -80));
    sprite.name = 'systemWelcomeText';
    scene.add(sprite);
    TextCreation.startSpeedTextEffect(sprite, 'Welcome to Object Explorer! This program is meant to be a visual medium of data and information. Use the scroll wheel to switch between abilities and try clicking on the various orbs scattered across the world', {
        wpm: 600,
        font: '40px Arial',
        fillStyle: '#6699CC',
        outlineStyle: '#095ceb',
        outlineWidth: 3,
        loop: false, // this seems to cause massive fps drops. and it is incapabled of looping intelligently across mutlipel in a performant way. set to false for now //TODO find a better way
    });
    //old
    /*
    const speedSprite = TextCreation.createTextSprite("Start", 2, new THREE.Vector3(50, 25, -80));
    scene.add(speedSprite);
  
    const txt: string = ""
    TextCreation.startSpeedTextEffect(speedSprite, "Welcome to Object Explorer! This program is meant to be a visual medium of data and information. Use the scroll wheel to switch between abilities and try clicking on the various orbs scattered across the world", {
      wpm: 600,
      font: '40px Arial',
      fillStyle: '#6699CC',
      outlineStyle: '#095ceb',
      outlineWidth: 3
      //backgroundColor: 'rgba(0,0,0,0.3)',
    });
    */
}
function createOrbButton(scene) {
    let apiOrbSphere = OrbFactory.createOrbByType('API_ORB', "Click me!");
    apiOrbSphere.setPosition(new THREE.Vector3(-300, 150, -300));
    apiOrbSphere.addAction({
        trigger: 'onActivate',
        kind: 'sprayViaOrbHarnessed',
        params: {
            byType: 'BLACKHOLE',
            first: true,
            fetcher: 'apiOrbs',
            args: { type: 'API_ORB' },
            baseVelocity: 5,
            sprayCoefficient: 2100,
            timeGap: global.baseTimeGap,
            useCache: true
        }
    });
    apiOrbSphere.addToScene(scene);
}
function createFetcherButtons(scene) {
    const origin = new THREE.Vector3(-300, 150, -300);
    const ui = {
        arcRadius: 180,
        lift: 12,
        miniScale: 0.18,
        miniRadius: 12,
    };
    const entries = [
        { fetcher: 'dockerSwarmOrbs', orbType: 'COMPUTER_ORB', label: 'Swarm' },
        { fetcher: 'registryOrbs', orbType: 'CONTAINER_IMAGE_ORB', label: 'Registry' },
        { fetcher: 'githubOrbs', orbType: 'GITHUB_ORB', label: 'Github' },
        { fetcher: 'dockerOrbs', orbType: 'DOCKER_CONTAINER_ORB', label: 'Docker' },
        { fetcher: 'endpointOrbs', orbType: 'CONTAINER_ENDPOINT_ORB', label: 'Endpoint' },
        { fetcher: 'domainOrbs', orbType: 'DOMAIN_ORB', label: 'Domain' },
        { fetcher: 'mathOrbs', orbType: 'MATH_ORB', label: 'Math' },
        { fetcher: 'desmosOrbs', orbType: 'DESMOS_ORB', label: 'Desmos' },
        { fetcher: 'promptOrbs', orbType: 'PROMPT_ORB', label: 'Prompt' },
        { fetcher: 'chatbotOrbs', orbType: 'CHATBOT_ORB', label: 'Chatbot' },
        { fetcher: 'textObjectOrbs', orbType: 'TEXT_OBJECT_ORB', label: 'Text Object' },
        { fetcher: 'databaseObjectOrbs', orbType: 'DATABASE_OBJECT_ORB', label: 'Database Object' },
        { fetcher: 'networkGatewayOrbs', orbType: 'NETWORK_GATEWAY_ORB', label: 'Network Gateway' },
    ];
    const total = entries.length;
    const start = Math.PI * 0.55;
    const end = -Math.PI * 0.05;
    entries.forEach((e, i) => {
        var _a;
        const t = total === 1 ? 0.5 : i / (total - 1);
        const angle = start + (end - start) * t;
        const pos = new THREE.Vector3(origin.x + Math.cos(angle) * ui.arcRadius, origin.y + ui.lift - 100, origin.z + Math.sin(angle) * ui.arcRadius);
        const btn = OrbFactory.createMiniOrbByType(e.orbType, e.label, {}, ui.miniScale, ui.miniRadius);
        if (!btn)
            return;
        btn.setPosition(pos);
        btn.addAction({
            trigger: 'onActivate',
            kind: 'sprayViaOrbHarnessed',
            params: {
                byType: 'BLACKHOLE',
                first: true,
                fetcher: e.fetcher,
                args: (_a = e.args) !== null && _a !== void 0 ? _a : {},
                baseVelocity: 5,
                sprayCoefficient: 2100,
                timeGap: global.baseTimeGap,
                useCache: true
            }
        });
        btn.addToScene(scene);
        //this sucks, would like to find a way to avoid this
        // 🔧 Final normalization after addToScene (some types attach meshes late)
        requestAnimationFrame(() => {
            OrbFactory.normalizeOrbSize(btn, ui.miniRadius, { includeSprites: false });
            // optional 2nd pass if you’ve got any double-late attachments:
            requestAnimationFrame(() => {
                OrbFactory.normalizeOrbSize(btn, ui.miniRadius, { includeSprites: false });
            });
        });
    });
}
function createOrbConnectionButtons(scene) {
    const origin = new THREE.Vector3(-300, 90, -300);
    const ui = {
        arcRadius: 180,
        lift: 12,
        miniScale: 0.18,
        miniRadius: 12,
    };
    const entries = [
        { orbType: 'SYSTEM_WILL_ORB', label: 'GitHub → Registry', fromType: 'GITHUB_ORB', profileLabel: 'Connect GitHub to Registry' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'GitHub → Containers', fromType: 'GITHUB_ORB', profileLabel: 'Connect GitHub to Containers' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Registry → Containers', fromType: 'CONTAINER_IMAGE_ORB', profileLabel: 'Connect Registry to Containers' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Containers → Endpoints', fromType: 'DOCKER_CONTAINER_ORB', profileLabel: 'Connect Containers to Endpoints' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Swarm → Containers', fromType: 'COMPUTER_ORB', profileLabel: 'Connect Swarm to Containers' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Domains → Domains', fromType: 'DOMAIN_ORB', profileLabel: 'Connect Domains to Domains' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Domains → Gateways', fromType: 'DOMAIN_ORB', profileLabel: 'Connect Domains to Network Gatways' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Gateways → Gateways', fromType: 'NETWORK_GATEWAY_ORB', profileLabel: 'Connect Network Gatways to Network Gatways' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'Gateways → Endpoints', fromType: 'NETWORK_GATEWAY_ORB', profileLabel: 'Connect Network Gatways to Endpoints' },
        { orbType: 'SYSTEM_WILL_ORB', label: 'TextObjects → TextObjects', fromType: 'TEXT_OBJECT_ORB', profileLabel: 'Connect Text Objects to Text Objects' },
    ];
    const total = entries.length;
    const start = Math.PI * 0.55;
    const end = -Math.PI * 0.05;
    entries.forEach((e, i) => {
        const t = total === 1 ? 0.5 : i / (total - 1);
        const angle = start + (end - start) * t;
        const pos = new THREE.Vector3(origin.x + Math.cos(angle) * ui.arcRadius, origin.y + ui.lift, origin.z + Math.sin(angle) * ui.arcRadius);
        const btn = OrbFactory.createMiniOrbByType(e.orbType, e.label, {}, ui.miniScale, ui.miniRadius);
        if (!btn)
            return;
        btn.setPosition(pos);
        // Trigger the config-driven join
        btn.addAction({
            trigger: 'onActivate',
            kind: 'connectByProfiles',
            params: {
                fromType: e.fromType,
                profileLabel: e.profileLabel
            }
        });
        btn.addToScene(scene);
        // same normalization pattern as fetchers
        requestAnimationFrame(() => {
            OrbFactory.normalizeOrbSize(btn, ui.miniRadius, { includeSprites: false });
            requestAnimationFrame(() => {
                OrbFactory.normalizeOrbSize(btn, ui.miniRadius, { includeSprites: false });
            });
        });
    });
}
function createConnectionStatusOrbs(scene) {
    scene.children
        .filter((child) => child.name.startsWith('streamStatusOrb:') || child.name.startsWith('streamStatusLine:'))
        .forEach((child) => scene.remove(child));
    const existingUnsubscribe = scene.userData.__streamHudUnsubscribe;
    if (typeof existingUnsubscribe === 'function') {
        existingUnsubscribe();
    }
    const streams = liveStreamRegistry.getSnapshot();
    const origin = new THREE.Vector3(-300, 142, -300);
    const arcRadius = 180;
    const start = Math.PI * 0.55;
    const end = -Math.PI * 0.05;
    const orbByName = new Map();
    streams.forEach((stream, index) => {
        var _a;
        const t = streams.length <= 1 ? 0.5 : index / (streams.length - 1);
        const angle = start + (end - start) * t;
        const pos = new THREE.Vector3(origin.x + Math.cos(angle) * arcRadius, origin.y, origin.z + Math.sin(angle) * arcRadius);
        const streamOrb = OrbFactory.createMiniOrbByType('STREAM_STATUS_ORB', stream.label, {}, 0.18, 12);
        if (!streamOrb) {
            return;
        }
        streamOrb.setPosition(pos);
        streamOrb.addToScene(scene);
        (_a = streamOrb.group) === null || _a === void 0 ? void 0 : _a.traverse((child) => {
            if (!(child instanceof THREE.Mesh)) {
                return;
            }
            if (Array.isArray(child.material)) {
                child.material = child.material.map((material) => material.clone());
            }
            else if (child.material) {
                child.material = child.material.clone();
            }
        });
        if (streamOrb.group) {
            streamOrb.group.name = `streamStatusOrb:${stream.name}`;
        }
        orbByName.set(stream.name, streamOrb);
    });
    const applyStateToOrb = (stream, orb) => {
        var _a;
        const coreColor = stream.isConnected ? 0x27d77a : 0xef5350;
        const coreEmissive = stream.isConnected ? 0x03230f : 0x2a100f;
        const borderColor = 0xffffff;
        const layerMeshes = (_a = orb.group) === null || _a === void 0 ? void 0 : _a.children.filter((child) => child instanceof THREE.Mesh);
        const coreMesh = layerMeshes === null || layerMeshes === void 0 ? void 0 : layerMeshes[0];
        const borderMesh = layerMeshes === null || layerMeshes === void 0 ? void 0 : layerMeshes[1];
        const applyColor = (mesh, color, emissive) => {
            if (!mesh) {
                return;
            }
            const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
            materials.forEach((material) => {
                if ('color' in material) {
                    material.color.setHex(color);
                }
                if ('emissive' in material) {
                    material.emissive.setHex(emissive);
                }
                material.needsUpdate = true;
            });
        };
        applyColor(coreMesh, coreColor, coreEmissive);
        applyColor(borderMesh, borderColor, 0x151515);
        if (orb.group) {
            orb.group.scale.setScalar(stream.isConnected ? 1.08 : 0.96);
        }
    };
    const applySnapshot = (snapshot) => {
        snapshot.forEach((stream) => {
            const orb = orbByName.get(stream.name);
            if (!orb)
                return;
            applyStateToOrb(stream, orb);
        });
    };
    applySnapshot(streams);
    scene.userData.__streamHudUnsubscribe = liveStreamRegistry.subscribe(applySnapshot);
}
function buildSystemWorld(context) {
    const { scene, world } = context;
    console.log('[SystemWorld] Building system world scene contents');
    // Most worlds should declare this
    scene.background = new THREE.Color(0xefedfa);
    scene.fog = new THREE.Fog(0xffffff, 0, global.arenaSize * 30);
    scene.add(ObjectCreation.roundedBox(new THREE.Vector3(0, 0.5, 0)));
    scene.add(TextCreation.createTextSprite("Object Explorer Prototype", 1, new THREE.Vector3(-20, 20, 20), undefined, undefined));
    // Replace the old transparent floor:
    //scene.add(ObjectCreation.createWorldFloor(arenaSize));
    //scene.add(ObjectCreation.createMirrorFloor(arenaSize));
    // add mirror + tint
    const { mirror, tintOverlay } = ObjectCreation.createMirrorFloor(global.arenaSize, {
        baseColor: 0x999999,
        y: 0.05,
        dpr: 1.5,
        textureScale: 0.9,
        clipBias: 0.003
    });
    scene.add(mirror);
    scene.add(tintOverlay);
    scene.add(ObjectCreation.createWorldAxis(20000, 20000, 1000));
    ObjectCreation.createTransparentSpheres(300, global.arenaSize).forEach(sphere => {
        sphere.name = `systemTransparentOrb-${sphere.id}`;
        scene.add(sphere);
    });
    addWelcomeMessage(scene);
    scene.add(ObjectCreation.createRoundedRectangle(15000, 10000, 10000, 500, 0x1285e3, //0x6699CC,
    new THREE.Vector3(-3000, 1000, 10000)));
    scene.add(ObjectCreation.createRoundedRectangle(9000, 7000, 7000, 500, 0x3320E3, new THREE.Vector3(10000, 3000, -2000)));
    scene.add(ObjectCreation.createRoundedRectangle(15000, 8000, 7000, 500, 0x095ceb, new THREE.Vector3(-16000, 2000, -20000)));
    scene.add(ObjectCreation.createDatabaseSymbol(230, 250, 0x157be8, 0x125280, new THREE.Vector3(2000, 200, -2000)));
    let bOrb = OrbFactory.createOrbByType("BLACKHOLE", "");
    bOrb.setPosition(startSprayPosition);
    bOrb.addToScene(scene);
    const dockerLayerCountEstimate = 9;
    const dockerLayerGapEstimate = 460;
    const dockerVerticalSpanEstimate = (dockerLayerCountEstimate + 1) * dockerLayerGapEstimate;
    const dockerMaxSubLayerRadiusEstimate = 2600;
    const dockerEnvelopeRadius = dockerMaxSubLayerRadiusEstimate * 1.5;
    buildGiantRainbowCylinderStack(scene, networkGatewayStackCenter.clone(), {
        regionRadiusOverrides: {
            'Docker Container Region': dockerEnvelopeRadius,
        },
        regionHeightOverrides: {
            'Docker Container Region': dockerVerticalSpanEstimate,
        },
    });
    const networkGatewayRegionOrb = getStackRegionOrb(scene, 'Network Gateway Region');
    if (networkGatewayRegionOrb) {
        bOrb.attachStream(networkGatewayRegionOrb, 'gateway');
    }
    createOrbButton(scene);
    createFetcherButtons(scene);
    createOrbConnectionButtons(scene);
    createConnectionStatusOrbs(scene);
    const orb = OrbFactory.createOrbByType("PROMPT_ORB", "Testing out high speed text displays on orbs");
    orb.setPosition(new THREE.Vector3(400, 500, -500));
    orb.addToScene(scene);
    // Enable speed text with WPM override
    // TODO this needs to be unified with addWelcomeMessage
    orb.enableSpeedText({ wpm: 500 });
    // Toggle on keypress
    window.addEventListener('keydown', (e) => {
        if (e.key === 't') {
            orb.toggleSpeedText({ wpm: 600 });
        }
    });
    const rainbowOrb1 = OrbFactory.createOrbByType("RAINBOW_NEST", "This is a test");
    rainbowOrb1.setPosition(new THREE.Vector3(-10000, 3000, 9000));
    rainbowOrb1.addToScene(scene);
    const registeredWorlds = global.worldRegistry.listWorlds();
    console.log('[SystemWorld] Registered worlds available for portal display', {
        slugs: registeredWorlds.map(world => world.slug),
    });
    const filteredWorlds = registeredWorlds.filter(entry => entry.slug !== 'system');
    if (filteredWorlds.length > 0) {
        const radius = 3200;
        const height = 620;
        const arcStart = Math.PI * 0.35;
        const arcEnd = Math.PI * 0.85;
        const computePosition = (index, total) => {
            const t = total <= 1 ? 0.5 : index / (total - 1);
            const angle = arcStart + (arcEnd - arcStart) * t;
            return new THREE.Vector3(Math.cos(angle) * radius, height, Math.sin(angle) * radius);
        };
        filteredWorlds.forEach((entry, index) => {
            var _a;
            const portal = createPortalOrb({
                label: entry.label,
                target: entry.sceneName,
                position: computePosition(index, filteredWorlds.length),
                resolution: 512,
                fov: 70,
                slug: entry.slug,
            });
            if (!portal)
                return;
            portal.addToScene(scene);
            (_a = portal.group) === null || _a === void 0 ? void 0 : _a.lookAt(new THREE.Vector3(0, height, 0));
            console.log('[SystemWorld] Added portal to system world', {
                target: entry.sceneName,
                positionIndex: index,
            });
        });
    }
    const sceneName = world.sceneName;
    registerScenePolicy(sceneName, { floorY: 2 });
    console.log('[SystemWorld] System world build complete');
}
export const SystemWorld = new World({
    slug: 'system',
    label: 'System',
    sceneName: 'system',
    build: buildSystemWorld,
});
global.worldRegistry.registerWorld(SystemWorld);
